module.exports = __webpack_public_path__ + "img/jituan.b0a547ff.png";